/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState } from 'react'
import { ConvertToTitleCase } from '../../../../CommonMethods/ConvertToTitleCase';
import ErrorMessage from '../../../../components/ErrorMessage';
import CommissionInput from '../../../../components/FloatinInput/CommissionInput';
import TooltipContainer from '../../../../components/TooltipContainer';

export default function MultipleInputs({ errorState, selectedRadio, toggleDropdown, selectedValue, state, handleInput, submitSelected, setsubmitSelected, handleAddMultiItems, type, DuplicateItems, setDuplicateItems, loading }) {
    const options = [{ name: "Commision Percentage", value: 'commission_percentage' }, { name: "Fixed Commission", value: 'fixed_commission' }];

    const [dropdownOpenStates, setDropdownOpenStates] = useState([]);

    const toggleDropdownOption = (index) => {
        const newDropdownOpenStates = [...dropdownOpenStates];
        newDropdownOpenStates[index] = !newDropdownOpenStates[index];
        setDropdownOpenStates(newDropdownOpenStates);
    }

    const GenerateKey = (commissionValue) => `${commissionValue.min_cart_value}-${commissionValue.max_cart_value}-${commissionValue.commission_type}-${commissionValue.commission}`;

    const getDuplicateIndices = () => {
        if (!state[type]?.items) return [];
        const items = state[type].items;
        const duplicates = [];
        for (let i = 0; i < items.length; i++) {
            for (let j = i + 1; j < items.length; j++) {
                if (items[i].min_cart_value === items[j].min_cart_value &&
                    items[i].max_cart_value === items[j].max_cart_value &&
                    items[i].commission_type === items[j].commission_type &&
                    items[i].min_cart_value && items[j].min_cart_value) {
                    if (!duplicates.includes(i)) duplicates.push(i);
                    if (!duplicates.includes(j)) duplicates.push(j);
                }
            }
        }
        return duplicates;
    };

    const duplicateIndices = getDuplicateIndices();

    const getFieldError = (item, field) => {
        const min = item.min_cart_value?.toString().trim() || '';
        const max = item.max_cart_value?.toString().trim() || '';
        const com = item.commission?.toString().trim() || '';
        const ct = item.commission_type?.toString().trim() || '';
        const any = min || max || com || ct;
        const val = item[field]?.toString().trim() || '';
        return submitSelected && (any || (!min && !max && !com && !ct)) && !val;
    };

    return (
        <>
            {state[type]?.items && state[type]?.items.map((item, i) => (
                <div key={i}>
                    {/* Single horizontal row: min | max | commission type | commission | button */}
                    <div className='flex items-start gap-3 mb-2'>

                        {/* Min cart value */}
                        <div className="w-[220px] relative" style={{minHeight: '80px'}}>
                            <CommissionInput
                                type="number"
                                state={item}
                                value={item.min_cart_value}
                                id="min_cart_value"
                                handleInput={handleInput}
                                submitSelected={submitSelected}
                                setsubmitSelected={setsubmitSelected}
                                className={`peer relative cursor-pointer text-sm font-semibold w-full px-4 py-4 placeholder:text-sm placeholder:font-semibold placeholder:text-[#1F1F1F] ${getFieldError(item, 'min_cart_value') ? 'input-error text-[#FC4523]' : 'input-border text-[#1F1F1F]'}`}
                                text="Minimum cart value"
                                optional={true}
                                labelCalss={`px-4 absolute block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 ${getFieldError(item, 'min_cart_value') ? 'text-[#FC4523] peer-focus:text-[#FC4523]' : 'text-[#1F1F1F] peer-focus:text-[#1F1F1F]'}`}
                                placeholder="Minimum cart value"
                                maxLength="12"
                                newType={type}
                                idx={i}
                                minVal="0"
                            />
                            {getFieldError(item, 'min_cart_value') && !loading && (
                                <ErrorMessage error message="This field is mandatory" classKey={'itext-f4 text-sm font-normal text-[#FC4523] mt-[8px] login-err'} />
                            )}
                        </div>

                        {/* Max cart value */}
                        <div className="w-[220px] relative" style={{minHeight: '80px'}}>
                            <CommissionInput
                                type="number"
                                state={item}
                                id="max_cart_value"
                                value={item.max_cart_value}
                                handleInput={handleInput}
                                submitSelected={submitSelected}
                                setsubmitSelected={setsubmitSelected}
                                className={`peer relative cursor-pointer text-sm font-semibold w-full px-4 py-4 placeholder:text-sm placeholder:font-semibold placeholder:text-[#1F1F1F] ${getFieldError(item, 'max_cart_value') ? 'input-error text-[#FC4523]' : 'input-border text-[#1F1F1F]'}`}
                                text="Maximum cart value"
                                optional={true}
                                labelCalss={`px-4 absolute block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 ${getFieldError(item, 'max_cart_value') ? 'text-[#FC4523] peer-focus:text-[#FC4523]' : 'text-[#1F1F1F] peer-focus:text-[#1F1F1F]'}`}
                                placeholder="Maximum cart value"
                                maxLength="12"
                                newType={type}
                                idx={i}
                                minVal="0"
                            />
                            {getFieldError(item, 'max_cart_value') && !loading && (
                                <ErrorMessage error message="This field is mandatory" classKey={'itext-f4 text-sm font-normal text-[#FC4523] mt-[8px] login-err'} />
                            )}
                        </div>

                        {/* Commission type dropdown */}
                        <div className="w-[220px] relative" style={{minHeight: '80px'}}>
                            <div className="dropdown">
                                <div className="relative">
                                    <input
                                        className={`peer relative cursor-pointer text-sm font-semibold w-full pl-[14px] pr-4 py-4 placeholder:text-sm placeholder:font-semibold placeholder:text-[#1F1F1F] ${getFieldError(item, 'commission_type') ? 'input-error text-[#FC4523]' : 'input-border text-[#1F1F1F]'}`}
                                        type="text"
                                        value={ConvertToTitleCase(item.commission_type?.replace(/_/g, ' '))}
                                        placeholder=''
                                        onClick={() => toggleDropdownOption(i)}
                                        data-testid="commission-dropdown"
                                        readOnly
                                        disabled={state.type === 'fixed_percentage'}
                                    />
                                    <label htmlFor="" className={`px-4 absolute block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-placeholder-shown:scale-100 ${item?.commission_type === '' ? '' : 'scale-75 -translate-y-4'} peer-placeholder-shown:translate-y-0 ${getFieldError(item, 'commission_type') ? 'text-[#FC4523] peer-focus:text-[#FC4523]' : 'text-[#1F1F1F] peer-focus:text-[#1F1F1F]'}`}>Commission type</label>
                                    <img
                                        src={getFieldError(item, 'commission_type') ? '/assets/images/error-chevron-down.svg' : '/assets/images/chevron-down.svg'}
                                        alt=""
                                        className="absolute top-4 right-5 cursor-pointer"
                                        onClick={() => toggleDropdownOption(i)}
                                    />
                                    {dropdownOpenStates[i] && (
                                        <ul className="dropdown-menu mt-1 w-full z-10 bg-white">
                                            {options.map((option, index) => (
                                                <li
                                                    data-testid={option?.value}
                                                    key={index}
                                                    onClick={() => {
                                                        handleInput(option, type, i, option);
                                                        toggleDropdownOption(i);
                                                    }}
                                                    className="dropdown-item cursor-pointer px-4 py-4 border border-[#DDDDDD] hover:bg-[#EB9DC7] rounded-[2px] text-sm font-semibold text-[#1F1F1F]"
                                                >
                                                    {option.name}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                    {getFieldError(item, 'commission_type') && !loading && (
                                        <ErrorMessage error message="This field is mandatory" classKey={'itext-f4 text-sm font-normal text-[#FC4523] mt-[8px] login-err'} />
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Commission value */}
                        <div className="w-[220px] relative" style={{minHeight: '80px'}}>
                            <CommissionInput
                                type="number"
                                state={item}
                                id="commission"
                                value={item.commission}
                                handleInput={handleInput}
                                submitSelected={submitSelected}
                                setsubmitSelected={setsubmitSelected}
                                className={`peer relative cursor-pointer text-sm font-semibold w-full px-4 py-4 placeholder:text-sm placeholder:font-semibold placeholder:text-[#1F1F1F] ${getFieldError(item, 'commission') ? 'input-error text-[#FC4523]' : 'input-border text-[#1F1F1F]'}`}
                                text="Commission"
                                optional={true}
                                labelCalss={`px-4 absolute block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 ${getFieldError(item, 'commission') ? 'text-[#FC4523] peer-focus:text-[#FC4523]' : 'text-[#1F1F1F] peer-focus:text-[#1F1F1F]'}`}
                                placeholder="Commission"
                                maxLength="16"
                                newType={type}
                                idx={i}
                                minVal="0"
                            />
                            {getFieldError(item, 'commission') && !loading && (
                                <ErrorMessage error message="This field is mandatory" classKey={'itext-f4 text-sm font-normal text-[#FC4523] mt-[8px] login-err'} />
                            )}
                        </div>

                        {/* Add / Delete button */}
                        <div className="flex items-center pt-3">
                            {state[type].items.length === 1 ? (
                                <TooltipContainer id="add" content={<img src="/assets/images/plus.svg" className="cursor-pointer hover:bg-[#FBEBF4] p-3 rounded-full" alt="" onClick={() => handleAddMultiItems(type)} />} text="Add" index={i} />
                            ) : (
                                <TooltipContainer id="delete" content={<img src="/assets/images/delete.svg" alt="" className="cursor-pointer hover:bg-[#FBEBF4] p-3 rounded-full" onClick={() => handleAddMultiItems(type, 'remove', i)} />} text="Delete" index={i} />
                            )}
                            {state[type].items.length - 1 === i && i !== 0 && (
                                <TooltipContainer id="addd" content={<img src="/assets/images/plus.svg" className="cursor-pointer hover:bg-[#FBEBF4] p-3 rounded-full" alt="" onClick={() => handleAddMultiItems(type)} />} text="Add" index={i} />
                            )}
                        </div>
                    </div>

                    {submitSelected && DuplicateItems?.includes(GenerateKey(item)) && (
                        <ErrorMessage error message={`This ${type.replace('_commision', '').replace('_', ' ')} commission already exists. Try a different one`} classKey={'itext-f4 text-sm font-normal text-[#FC4523] login-err text-start'} />
                    )}
                    {submitSelected && duplicateIndices.includes(i) && (
                        <ErrorMessage error message="This value based commission already exists. Try a different one." classKey={'itext-f4 text-sm font-normal text-[#FC4523] -mt-4 login-err text-start'} />
                    )}
                    {submitSelected && !loading && item.min_cart_value && item.max_cart_value && Number(item.max_cart_value) === Number(item.min_cart_value) && (
                        <ErrorMessage error message="Minimum and maximum cart values must differ" classKey={'itext-f4 text-sm font-normal text-[#FC4523] login-err text-start'} />
                    )}
                    {submitSelected && !loading && item.min_cart_value && item.max_cart_value && Number(item.max_cart_value) < Number(item.min_cart_value) && (
                        <ErrorMessage error message="Minimum cart value cannot exceed the maximum cart value" classKey={'itext-f4 text-sm font-normal text-[#FC4523] login-err text-start'} />
                    )}
                </div>
            ))}
        </>
    )
}
